/**
 * Set up routing for all SiteLocation views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import siteLocation views
import SiteLocationList from './views/SiteLocationList.js.jsx';
import SingleSiteLocation from './views/SingleSiteLocation.js.jsx';

class SiteLocationRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute exact login={true} path="/site-locations" component={SiteLocationList} />
        <YTRoute exact login={true} path="/site-locations/:siteLocationId" component={SingleSiteLocation}/>
      </Switch>
    )
  }
}

export default SiteLocationRouter;



// WEBPACK FOOTER //
// modules/siteLocation/SiteLocationRouter.js.jsx